import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Api_Url } from "../../../config/config";
import moment from "moment";
import { DatePicker } from "antd";
import { InfoToast } from "../../ToastComponent";

const BuisnessPDFilter = ({ handleFilterBuisnessPdFunc }) => {
  const [focusedClientId, setFocusedClientId] = useState(false);
  const [inputBranchValue, setInputBranchValue] = useState(null);
  const [inputValueMobileNumber, setInputValueMobileNumber] = useState(null);
  const [inputStatusValue, setInputStatusValue] = useState(null);
  const [focusedEmployeeName, setFocusedEmployeeName] = useState(false);
  const [inputTeamValue, setInputTeamValue] = useState(null);
  const [inputValueEmployeeName, setInputValueEmployeeName] = useState(null);
  const [branch, setBranch] = useState([]);
  const [status, setStatus] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userId, setUserId] = useState("");
  const [totalLength, setTotalLength] = useState(0)

  console.log(totalLength)

  const handleLabelClickClientId = () => {
    setFocusedClientId(true);
  };

  const handleInputBlurClientId = () => {
    if (inputBranchValue === "") {
      setFocusedClientId(false);
    }
  };

  useEffect(() => {
    const LoginUser = JSON.parse(sessionStorage.getItem("user"))?.id;
    setUserId(LoginUser);
  }, []);

  const handleInputChangeClientId = (e) => {
    const value = e.target.value;
    setInputValueMobileNumber(value);
    if (value !== "" && !focusedClientId) {
      setFocusedClientId(true);
    }
  };

  const handleLabelClickEmployeeName = () => {
    setFocusedEmployeeName(true);
  };

  const handleInputBlurEmployeeName = () => {
    if (inputValueEmployeeName === "") {
      setFocusedEmployeeName(false);
    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };

  // Branch API
  const handleDataBranchFunc = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.error("branch data error", error);
    }
  };

  // Status API
  const handleDataStatusFunc = async () => {
    try {
      const response = await axios.get(`${Api_Url}api/v1/Status/all/10`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      setStatus([{ id: "all", name: "Select All" }, ...response?.data?.data]);
    } catch (error) {
      console.log("status data error", error);
    }
  };

  // Teams Member
  const handleTeamMembersFunc = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/Team/${userId}/team-members`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTeamMembers([
        { id: "all", name: "Select All" },
        ...response?.data?.data,
      ]);
    } catch (error) {
      console.error("Team Members Api Error", error);
    }
  };

  useEffect(() => {
    handleDataBranchFunc();
    handleDataStatusFunc();
    handleTeamMembersFunc();
  }, []);

  // Filter API
// Filter API
const handleFilterApply = async () => {
  const filters = [];
  if (inputBranchValue && inputBranchValue.value !== "all") {
    filters.push(`BranchId=${inputBranchValue.value}`);
  }
  if (inputStatusValue && inputStatusValue.value !== "all") {
    filters.push(`StatusId=${inputStatusValue.value}`);
  }
  if (inputTeamValue && inputTeamValue.value !== "all") {
    filters.push(`UserId=${inputTeamValue.value}`);
  }
  if (inputValueMobileNumber) {
    filters.push(`Mobile=${inputValueMobileNumber}`);
  }
  if (startDate) {
    const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
    filters.push(`StartDate=${normalizedStartDate}`);
  }
  if (endDate) {
    const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
    filters.push(`EndDate=${normalizedEndDate}`);
  }

  try {
    const queryString = `?${filters.join("&")}`;
    handleFilterBuisnessPdFunc([]);
    const response = await axios.get(
      `${Api_Url}api/v1/BusinessPd${queryString}&PageNumber=1&PageSize=1000`,
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      }
    );

    // Update totalLength state with the length of the data
    const dataLength = response.data?.data?.length; // Assuming the API returns totalLength
    setTotalLength(dataLength);

    // Dynamically adjust PageSize
    // let adjustedPageSize = dataLength > 1000 ? 100 : 50;
    const newQueryString = `${Api_Url}api/v1/BusinessPd${queryString}&PageNumber=1&PageSize=${dataLength}`;
    
    const adjustedResponse = await axios.get(newQueryString, {
      headers: {
        Authorization: `Bearer ${
          JSON.parse(sessionStorage.getItem("user")).accessToken
        }`,
      },
    });

    handleFilterBuisnessPdFunc(adjustedResponse?.data?.data);
  } catch (error) {
    console.error("Error filtering activities", error);
  }
};



  // const handleFilterApply = async () => {
  //   const filters = [];
  //   if (inputBranchValue && inputBranchValue.value !== "all") {
  //     filters.push(`BranchId=${inputBranchValue.value}`);
  //   }
  //   if (inputStatusValue && inputStatusValue.value !== "all") {
  //     filters.push(`StatusId=${inputStatusValue.value}`);
  //   }
  //   if (inputTeamValue && inputTeamValue.value !== "all") {
  //     filters.push(`UserId=${inputTeamValue.value}`);
  //   }
  //   if (inputValueMobileNumber) {
  //     filters.push(`Mobile=${inputValueMobileNumber}`);
  //   }
  //   if (startDate) {
  //     const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
  //     filters.push(`StartDate=${normalizedStartDate}`);
  //   }
  //   if (endDate) {
  //     const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
  //     filters.push(`EndDate=${normalizedEndDate}`);
  //   }
  //   // if (filters.length === 0) {
  //   //   InfoToast("Please select at least one filter to apply.");
  //   //   return;
  //   // }
  //   try {
  //     const queryString = `?${filters.join("&")}`;
  //     handleFilterBuisnessPdFunc([]);
  //     const response = await axios.get(
        
  //       `${Api_Url}api/v1/BusinessPd${queryString}&PageNumber=1&PageSize=100`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${
  //             JSON.parse(sessionStorage.getItem("user")).accessToken
  //           }`,
  //         },
  //       }
  //     );
  //     // console.log("tt",response.data.data.length)
      
  //     handleFilterBuisnessPdFunc(response?.data?.data);
  //   } catch (error) {
  //     console.error("Error filtering activities", error);
  //   }
  // };

  const handleBranchChange = (selectedBranch) => {
    setInputBranchValue(selectedBranch);
  };

  const handleInputChangeEmployeeName = (e) => {
    const value = e.target.value;
    setInputValueEmployeeName(value);
    if (value !== "" && !focusedEmployeeName) {
      setFocusedEmployeeName(true);
    }
  };

  const handleStatusChange = (selectedStatus) => {
    setInputStatusValue(selectedStatus);
  };

  const handleTeamChange = (selectedTeam) => {
    setInputTeamValue(selectedTeam);
  };

  return (
    <>
      <div className="row filter-row">
        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={branch.map((branch) => ({
                value: branch.id,
                label: branch.name,
              }))}
              value={inputBranchValue}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() => setFocusedClientId(inputBranchValue ? true : false)}
              onChange={handleBranchChange}
              placeholder="Select Branch"
              styles={customStyles}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedClientId
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <Select
              options={status.map((status) => ({
                value: status.id,
                label: status.name,
              }))}
              value={inputStatusValue}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() => setFocusedClientId(inputStatusValue ? true : false)}
              onChange={handleStatusChange}
              placeholder="Select Status"
              styles={customStyles}
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div
            className={
              focusedEmployeeName
                ? "input-block form-focus focused"
                : "input-block form-focus"
            }
          >
            <input
              type="text"
              className="form-control floating"
              value={inputValueEmployeeName}
              onFocus={handleLabelClickEmployeeName}
              onBlur={handleInputBlurEmployeeName}
              onChange={handleInputChangeClientId}
            />
            <label
              className="focus-label"
              onClick={handleLabelClickEmployeeName}
            >
              Mobile Number
            </label>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <Select
              options={teamMembers.map((team) => ({
                value: team.id,
                label: `${team.firstName} ${team.lastName}`,
              }))}
              placeholder="Select Team"
              value={inputTeamValue}
              onFocus={() => setFocusedClientId(true)}
              onBlur={() => setFocusedClientId(inputTeamValue ? true : false)}
              onChange={handleTeamChange}
              styles={customStyles}
            />
            <label className="focus-label">Team Member</label>
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <DatePicker
              value={startDate ? moment(startDate) : null}
              onChange={(date) => setStartDate(date ? date.toDate() : null)}
              format="DD/MM/YYYY"
              placeholder="Start Date"
              className="form-control"
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <div className="input-block form-focus select-focus">
            <DatePicker
              value={endDate ? moment(endDate) : null}
              onChange={(date) => setEndDate(date ? date.toDate() : null)}
              format="DD/MM/YYYY"
              placeholder="End Date"
              className="form-control"
            />
          </div>
        </div>

        <div className="col-sm-6 col-md-3">
          <button
            to="#"
            onClick={handleFilterApply}
            className="btn btn-success btn-block w-100"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </>
  );
};

export default BuisnessPDFilter;






// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Select from "react-select";
// import { Api_Url } from "../../../config/config";
// import moment from "moment";
// import { DatePicker } from "antd";
// import { InfoToast } from "../../ToastComponent";

// const BuisnessPDFilter = ({ handleFilterBuisnessPdFunc }) => {
//   const [focusedClientId, setFocusedClientId] = useState(false);
//   const [inputBranchValue, setInputBranchValue] = useState(null);
//   const [inputValueMobileNumber, setInputValueMobileNumber] = useState(null);
//   const [inputStatusValue, setInputStatusValue] = useState(null);
//   const [focusedEmployeeName, setFocusedEmployeeName] = useState(false);
//   const [inputTeamValue, setInputTeamValue] = useState(null);
//   const [inputValueEmployeeName, setInputValueEmployeeName] = useState(null);
//   const [branch, setBranch] = useState([]);
//   const [status, setStatus] = useState([]);
//   const [teamMembers, setTeamMembers] = useState([]);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [userId, setUserId] = useState("");

//   const handleLabelClickClientId = () => {
//     setFocusedClientId(true);
//   };

//   const handleInputBlurClientId = () => {
//     if (inputBranchValue === "") {
//       setFocusedClientId(false);
//     }
//   };

//   useEffect(() => {
//     const LoginUser = JSON.parse(sessionStorage.getItem("user"))?.id;
//     setUserId(LoginUser);
//   }, []);

//   const handleInputChangeClientId = (e) => {
//     const value = e.target.value;
//     setInputValueMobileNumber(value);
//     if (value !== "" && !focusedClientId) {
//       setFocusedClientId(true);
//     }
//   };

//   const handleLabelClickEmployeeName = () => {
//     setFocusedEmployeeName(true);
//   };

//   const handleInputBlurEmployeeName = () => {
//     if (inputValueEmployeeName === "") {
//       setFocusedEmployeeName(false);
//     }
//   };

//   const customStyles = {
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
//       color: state.isFocused ? "#fff" : "#000",
//       "&:hover": {
//         backgroundColor: "#ff9b44",
//       },
//     }),
//   };

//   // Branch API
//   const handleDataBranchFunc = async () => {
//     try {
//       const response = await axios.get(
//         `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       setBranch([{ id: "all", name: "Select All" }, ...response?.data?.data]);
//     } catch (error) {
//       console.error("branch data error", error);
//     }
//   };

//   // Status API
//   const handleDataStatusFunc = async () => {
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Status/all/10`, {
//         headers: {
//           Authorization: `Bearer ${
//             JSON.parse(sessionStorage.getItem("user")).accessToken
//           }`,
//         },
//       });
//       setStatus([{ id: "all", name: "Select All" }, ...response?.data?.data]);
//     } catch (error) {
//       console.log("status data error", error);
//     }
//   };

//   // Teams Member
//   const handleTeamMembersFunc = async () => {
//     try {
//       const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
//       const response = await axios.get(
//         `${Api_Url}api/v1/Team/${userId}/team-members`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       setTeamMembers([
//         { id: "all", name: "Select All" },
//         ...response?.data?.data,
//       ]);
//     } catch (error) {
//       console.error("Team Members Api Error", error);
//     }
//   };

//   useEffect(() => {
//     handleDataBranchFunc();
//     handleDataStatusFunc();
//     handleTeamMembersFunc();
//   }, []);

//   // Filter API
//   const handleFilterApply = async () => {
//     const filters = [];
//     if (inputBranchValue && inputBranchValue.value !== "all") {
//       filters.push(`BranchId=${inputBranchValue.value}`);
//     }
//     if (inputStatusValue && inputStatusValue.value !== "all") {
//       filters.push(`StatusId=${inputStatusValue.value}`);
//     }
//     if (inputTeamValue && inputTeamValue.value !== "all") {
//       filters.push(`UserId=${inputTeamValue.value}`);
//     }
//     if (inputValueMobileNumber) {
//       filters.push(`Mobile=${inputValueMobileNumber}`);
//     }
//     if (startDate) {
//       const normalizedStartDate = moment(startDate).format("YYYY-MM-DD");
//       filters.push(`StartDate=${normalizedStartDate}`);
//     }
//     if (endDate) {
//       const normalizedEndDate = moment(endDate).format("YYYY-MM-DD");
//       filters.push(`EndDate=${normalizedEndDate}`);
//     }
//     // if (filters.length === 0) {
//     //   InfoToast("Please select at least one filter to apply.");
//     //   return;
//     // }
//     try {
//       const queryString = `?${filters.join("&")}`;
//       handleFilterBuisnessPdFunc([]);
//       const response = await axios.get(
//         `${Api_Url}api/v1/BusinessPd${queryString}&PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       handleFilterBuisnessPdFunc(response?.data?.data);
//     } catch (error) {
//       console.error("Error filtering activities", error);
//     }
//   };

//   const handleBranchChange = (selectedBranch) => {
//     setInputBranchValue(selectedBranch);
//   };

//   const handleInputChangeEmployeeName = (e) => {
//     const value = e.target.value;
//     setInputValueEmployeeName(value);
//     if (value !== "" && !focusedEmployeeName) {
//       setFocusedEmployeeName(true);
//     }
//   };

//   const handleStatusChange = (selectedStatus) => {
//     setInputStatusValue(selectedStatus);
//   };

//   const handleTeamChange = (selectedTeam) => {
//     setInputTeamValue(selectedTeam);
//   };

//   return (
//     <>
//       <div className="row filter-row">
//         <div className="col-sm-6 col-md-3">
//           <div
//             className={
//               focusedClientId
//                 ? "input-block form-focus focused"
//                 : "input-block form-focus"
//             }
//           >
//             <Select
//               options={branch.map((branch) => ({
//                 value: branch.id,
//                 label: branch.name,
//               }))}
//               value={inputBranchValue}
//               onFocus={() => setFocusedClientId(true)}
//               onBlur={() => setFocusedClientId(inputBranchValue ? true : false)}
//               onChange={handleBranchChange}
//               placeholder="Select Branch"
//               styles={customStyles}
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div
//             className={
//               focusedClientId
//                 ? "input-block form-focus focused"
//                 : "input-block form-focus"
//             }
//           >
//             <Select
//               options={status.map((status) => ({
//                 value: status.id,
//                 label: status.name,
//               }))}
//               value={inputStatusValue}
//               onFocus={() => setFocusedClientId(true)}
//               onBlur={() => setFocusedClientId(inputStatusValue ? true : false)}
//               onChange={handleStatusChange}
//               placeholder="Select Status"
//               styles={customStyles}
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div
//             className={
//               focusedEmployeeName
//                 ? "input-block form-focus focused"
//                 : "input-block form-focus"
//             }
//           >
//             <input
//               type="text"
//               className="form-control floating"
//               value={inputValueEmployeeName}
//               onFocus={handleLabelClickEmployeeName}
//               onBlur={handleInputBlurEmployeeName}
//               onChange={handleInputChangeClientId}
//             />
//             <label
//               className="focus-label"
//               onClick={handleLabelClickEmployeeName}
//             >
//               Mobile Number
//             </label>
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <Select
//               options={teamMembers.map((team) => ({
//                 value: team.id,
//                 label: `${team.firstName} ${team.lastName}`,
//               }))}
//               placeholder="Select Team"
//               value={inputTeamValue}
//               onFocus={() => setFocusedClientId(true)}
//               onBlur={() => setFocusedClientId(inputTeamValue ? true : false)}
//               onChange={handleTeamChange}
//               styles={customStyles}
//             />
//             <label className="focus-label">Team Member</label>
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <DatePicker
//               value={startDate ? moment(startDate) : null}
//               onChange={(date) => setStartDate(date ? date.toDate() : null)}
//               format="DD/MM/YYYY"
//               placeholder="Start Date"
//               className="form-control"
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <div className="input-block form-focus select-focus">
//             <DatePicker
//               value={endDate ? moment(endDate) : null}
//               onChange={(date) => setEndDate(date ? date.toDate() : null)}
//               format="DD/MM/YYYY"
//               placeholder="End Date"
//               className="form-control"
//             />
//           </div>
//         </div>

//         <div className="col-sm-6 col-md-3">
//           <button
//             to="#"
//             onClick={handleFilterApply}
//             className="btn btn-success btn-block w-100"
//           >
//             Apply Filter
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default BuisnessPDFilter;
